<template>
  <div style="position: relative;min-height: 200px">
    <v-container>
      <div v-if="loading || loadingBotOrigins || loadingFlow" class="text-xs-center">
        <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
      </div>
      <template v-else>
        <template v-for="admin in admins">
          <div class="z-border-red mb-2 " :key="admin.adminid" v-if="botorigins && flows">
            <add-admin
              type="edit"
              :flows="flows"
              :botorigin="botorigins"
              :value="admin"
              @onSave="onEdit"
              @onDelete="onDelete(admin.adminid)"
            ></add-admin>
          </div>
        </template>

        <div
          class="add-conversation text-xs-center"
          style="cursor: pointer"
          @click="isAdd = true"
          v-if="!isAdd"
        >
          <i class="fa fa-plus middle"></i>
          {{ $t('Add admin') }}
        </div>
        <div class="z-border-red mb-2 pa-2" v-else>
          <add-admin
            type="add"
            :flows="flows"
            :botorigin="botorigins"
            @onCancel="isAdd = false"
            @onSave="onSave"
          ></add-admin>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import AddAdmin from './AddAdmin'
export default {
  data() {
    return {
      isAdd: false,
      flows: undefined,
      loadingAddAdmin: false,
      loadingFlow: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      admins: 'getAdminList',
      loading: 'getLoadingAdminList',
      botorigins: 'getBotOrigins',
      loadingBotOrigins: 'getLoadingBotOrigins',
      currentLang: 'currentLang'
    })
  },
  components: {
    AddAdmin
  },
  async mounted() {
    this.loadingFlow = true
    if (this.$store.state.superadmin.includes(this.$store.state.userid)) {
      await this.$store.dispatch('loadAllAdmins')
    }
    await this.$store.dispatch('loadAllBotOrigins')
    await this.getAllFlow()
    await this.$nextTick()
    this.loadingFlow = false
  },
  methods: {
    async getAllFlow() {
      var response = await api.getAllFlow()
      console.log('load flow')
      this.flows = response.data ? response.data : []
    },
    async onEdit(payload) {
      // editFlowDetail
      var vm = this
      this.isAdd = false

      var data = payload.data

      vm.loadingAddAdmin = true
      try {
        await api.addAdmin(data)

        await vm.$store.dispatch('loadAllAdmins')
        // await vm.$store.dispatch('loadFlowList')
        await this.$swal.fire({
          type: 'success',
          title: this.$t('Success')
        })
        if (this.$store.state.userid == payload.data.adminid && payload.isLogout) {
          this.$store.dispatch('logout', null)
          this.$router.push('/' + this.currentLang + '/login')
        }

        vm.loadingAddAdmin = false
      } catch (error) {
        vm.loadingAddAdmin = false
      }
    },
    async onDelete(id) {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete this?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.loadingAddFlow = true
        var data = {
          adminid: id
        }
        try {
          await api.deleteAdmin(data)

          await vm.$store.dispatch('loadAllAdmins')
          // await vm.$store.dispatch('loadFlowList')

          vm.loadingAddFlow = false
        } catch (error) {
          vm.loadingAddFlow = false
        }
      }
    },
    async onSave(payload) {
      var vm = this
      this.isAdd = false

      vm.loadingAddFlow = true
      try {
        var response = await api.addAdmin(payload.data)

        await vm.$store.dispatch('loadAllAdmins')
        await this.$swal.fire({
          type: 'success',
          title: this.$t('Success')
        })

        // await vm.$store.dispatch('loadFlowList')

        vm.loadingAddFlow = false
      } catch (error) {
        vm.loadingAddFlow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AdminSetting.vue